import {DOM} from "../../../../../plugins/levcharity/resources/scripts/helpers/DOM";

export  class ScrollTo {

    constructor() {
        this.#addEvents();
        this.init();
    }

    init() {
        this.#scrollToTop()

    }


    async #addEvents() {
        DOM.addEvent('scroll', document, () => {
           this.#scrollToTop();
        });

        DOM.addEvent('click', '.scroll-to-top', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });

    }

    #scrollToTop(){
        const btn = document.querySelector('.scroll-to-top');
        if (!btn) return;

        if (window.scrollY > 100) {
            btn.classList.remove('hidden');
        } else {
            btn.classList.add('hidden');
        }
    }

}